/* 

Copyright© Celligence International, LLC - 2024

This software program is protected by copyright laws and is the property of
Celligence International, LLC (Celligence). Any unauthorized reproduction,
distribution, modification, or public display of this program, without the
explicit permission of Celligence is strictly prohibited. If you have gained
access to this program without the expressed approval of Celligence report
the incident to legal@celligence.com.

*/

//Jacques Bega
//hook that grabs list of tax assessors given a particular state and tax type
import { QueryFunctionContext, useQuery } from '@tanstack/react-query';
import { fetchTaxAssessors } from '../queryFunctions';

const useTaxAssessors = (impoundType: string, stateCode: string, token: string) => {
  return useQuery({
    queryKey: [impoundType, stateCode, token, 'taxAssessors'],
    queryFn: ({ signal }: QueryFunctionContext) => fetchTaxAssessors(signal, token, stateCode, impoundType),
    refetchOnWindowFocus: false,
    enabled: impoundType.trim() !== '' && impoundType.startsWith('TX'),
  });
};

export default useTaxAssessors;
